export function isDeviceMobile(viewDevice) {
  return /mobile/i.test(viewDevice);
}
